import { forwardRef, Ref, type SVGProps } from 'react';

const SvgPaymentMastercard = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 24"
    ref={ref}
    {...props}
  >
    <rect
      width={34}
      height={23}
      x={0.5}
      y={0.5}
      fill="#fff"
      stroke="#cdd7d6"
      rx={2.5}
    />
    <path
      fill="#ED0006"
      d="M22.176 5c3.768 0 6.823 3.091 6.823 6.903 0 3.813-3.055 6.903-6.823 6.903a6.75 6.75 0 0 1-4.427-1.652 6.75 6.75 0 0 1-4.425 1.652c-3.768 0-6.824-3.09-6.824-6.903S9.556 5 13.324 5a6.75 6.75 0 0 1 4.425 1.65A6.75 6.75 0 0 1 22.176 5"
    />
    <path
      fill="#F9A000"
      d="M22.176 5c3.768 0 6.823 3.091 6.823 6.903s-3.055 6.902-6.823 6.903a6.75 6.75 0 0 1-4.426-1.652 6.92 6.92 0 0 0 2.397-5.25A6.92 6.92 0 0 0 17.75 6.65 6.75 6.75 0 0 1 22.176 5"
    />
    <path
      fill="#FF5E00"
      d="M17.748 6.651a6.92 6.92 0 0 1 2.397 5.252 6.92 6.92 0 0 1-2.397 5.25 6.92 6.92 0 0 1-2.396-5.25 6.92 6.92 0 0 1 2.396-5.252"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPaymentMastercard);
export default ForwardRef;
